import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Shield } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const FloatingAdminButton = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on admin pages — you're already there
  const isAdminPage = location.pathname.startsWith("/admin");

  useEffect(() => {
    const checkAdmin = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) { setIsAdmin(false); return; }

      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", session.user.id);

      setIsAdmin((data || []).some(r => r.role === "admin" || r.role === "moderator"));
    };

    checkAdmin();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkAdmin();
    });

    return () => subscription.unsubscribe();
  }, []);

  if (!isAdmin || isAdminPage) return null;

  return (
    <button
      onClick={() => navigate("/admin")}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-primary px-4 py-3 text-primary-foreground shadow-lg transition-all hover:scale-105 hover:shadow-xl active:scale-95 touch-manipulation"
      aria-label="Go to Admin"
    >
      <Shield className="h-5 w-5" />
      <span className="text-sm font-semibold hidden sm:inline">Admin</span>
    </button>
  );
};

export default FloatingAdminButton;
